import React from 'react';
import BaseComponent from 'WebsiteApp/components/BaseComponent';
import TextField from '@material-ui/core/TextField';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  // For Underline Color After Click
  palette: {
    primary: { main: "rgba(255,255,255,1)" },
  },
  // For Underline Hover Color
  overrides: {
    MuiInput: {
      underline: {
        '&:before': {
          borderBottom: 'none !important',
        },
        '&:after': {
          borderBottom: 'none !important',
        },
      },
    }
  }
});

export default class InputField extends BaseComponent {
  constructor() {
    super();
    this.state = {
    };
  }
  /**
   * Get class name
   *
   * @returns {string}
   */
  getClassName() {
    let classNames = ['input-group'];
    if (this.props.fullWidth) {
      classNames.push('fulled');
    }

    return classNames.join(' ');
  }

  /**
   * Handle input change
   *
   * @param e
   */
  handleInputChange(e) {
    this.props.handler.handleInputChange(e);
  }
  getValidationError() {
    let messages = [];

    if (this.props.handler) {
      this.props.handler.getErrors().filter(x => x.field == this.props.name).forEach(
        error => messages.push(error.message)
      )
    }
    if (messages.length == 0) {
      return null;
    }
    const error =
      this.props.doNotJoinErrors && messages[0].length > 0
        ? messages[0][0]
        : messages.join("<br/>");

    return (
      <div className="validation-message" key={this.props.name + "-error"}>
        {error}
      </div>
    );
  }

  /**
   * Render input
   *
   * @returns {XML}
   */
  render() {
    let className = this.getClassName();
    let validationError = this.getValidationError();
    return (
      <div className={this.props.className} style={{ position: 'relative' }}>
        <MuiThemeProvider theme={this.props.muiTheme ? this.props.muiTheme : theme}>
          <TextField
            ref="actualInput"
            label={this.props.label}
            className={this.props.className}
            type={this.props.type}
            placeholder={this.props.placeholder}
            name={this.props.name}
            inputProps={this.props.inputProps}
            InputLabelProps={{
              shrink: true,
            }}
            onFocus={this.props.onFocus}
            onBlur={this.props.onBlur}
            value={this.props.value}
            onChange={this.handleInputChange.bind(this)}
            {...this.props.materialProps} />
        </MuiThemeProvider>
        {validationError}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/elements/form/fields/InputField.js